import { useCrossColumnRowSync } from "../../../../../hooks/useCrossColumnRowSync";

/**
 * Keeps Program Insights week columns visually aligned: for each `data-insights-sync-row`
 * value, sets every matching element’s `min-height` to the largest natural height in that row.
 *
 * @param {boolean} enabled — when false, no observers or DOM writes (e.g. tests).
 * @returns {React.RefObject<HTMLDivElement|null>} attach to the panel grid container.
 */
export function useProgramInsightsCrossColumnRowSync(enabled) {
  return useCrossColumnRowSync(enabled, "data-insights-sync-row");
}
